import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ISD = ["+91", "+1", "+44", "+971", "+966", "+974", "+965", "+968", "+65", "+60", "+63", "+62", "+880", "+94", "+977", "+92", "+86", "+81", "+82", "+61", "+49", "+33", "+31", "+30", "+357", "+7", "+380", "+27", "+234", "+20"];

export const EMPTY_ADDRESS = { house: "", area: "", landmark: "", district: "", state: "", country: "India", pin_code: "" };

const PARTS = [
  ["house", "House / Flat No", "e.g. Flat 4B, Sea View", "sm:col-span-1"],
  ["area", "Complex / Area / Road Name", "e.g. Marine Drive, Colaba", "sm:col-span-1"],
  ["landmark", "Landmark (optional)", "e.g. Near Gateway of India", "sm:col-span-2"],
  ["district", "District", "e.g. Mumbai"],
  ["state", "State", "e.g. Maharashtra"],
  ["country", "Country", "e.g. India"],
  ["pin_code", "Pin Code", "e.g. 400005"],
];

export function addressError(a, label) {
  const missing = PARTS.filter(([k]) => k !== "landmark" && !String(a[k] || "").trim());
  if (missing.length) return `${label}: please fill in ${missing.map(([, l]) => l).join(", ")}`;
  const india = ["india", "in"].includes(a.country.trim().toLowerCase());
  if (india && !/^\d{6}$/.test(a.pin_code.trim())) return `${label}: Pin Code must be 6 digits for India`;
  if (!india && !/^[A-Za-z0-9 -]{3,10}$/.test(a.pin_code.trim())) return `${label}: Pin Code looks invalid`;
  return null;
}

export function AddressBlock({ title, value, onChange, prefix }) {
  return (
    <fieldset className="border border-slate-200 rounded-lg p-4 sm:col-span-2" data-testid={`${prefix}-block`}>
      <legend className="px-1.5 text-sm font-semibold text-slate-800">{title}</legend>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {PARTS.map(([k, label, ph, span]) => (
          <div key={k} className={`space-y-1.5 ${span || ""}`}>
            <Label htmlFor={`${prefix}-${k}`} className="text-xs text-slate-600">{label}</Label>
            <Input id={`${prefix}-${k}`} value={value[k] || ""} placeholder={ph} inputMode={k === "pin_code" ? "numeric" : undefined}
              onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`${prefix}-${k}-input`} />
          </div>
        ))}
      </div>
    </fieldset>
  );
}

export function mobileError(code, number) {
  if (!/^\+\d{1,4}$/.test(code.trim())) return "Country code must look like +91";
  if (!/^\d+$/.test(number)) return "Enter the mobile number (digits only)";
  if (number.length !== 10) return "Mobile must be 10 digits";
  return null;
}

export function MobileField({ label, value, onChange, prefix }) {
  const [code, number] = (value || "+91 ").split(" ");
  return <MobileInput label={label} code={code || "+91"} number={number || ""} prefix={prefix}
    onChange={(c, n) => onChange(`${c} ${n}`)} />;
}

export function MobileInput({ label, code, number, onChange, prefix }) {
  const err = number ? mobileError(code, number) : null;
  return (
    <div className="space-y-1.5">
      <Label htmlFor={`${prefix}-number`}>{label}</Label>
      <div className="flex gap-2">
        <Select value={code} onValueChange={(v) => onChange(v, number)}>
          <SelectTrigger className="w-24 font-mono" aria-label="Country code" data-testid={`${prefix}-code-input`}><SelectValue /></SelectTrigger>
          <SelectContent>{(ISD.includes(code) ? ISD : [code, ...ISD]).map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Input id={`${prefix}-number`} value={number} inputMode="numeric" placeholder="10-digit number"
          onChange={(e) => onChange(code, e.target.value.replace(/\D/g, "").slice(0, 10))}
          className={`flex-1 font-mono ${err ? "border-rose-400 focus-visible:ring-rose-300" : ""}`} data-testid={`${prefix}-number-input`} />
      </div>
      {err && <div className="text-xs text-rose-600" data-testid={`${prefix}-error`}>{err}</div>}
    </div>
  );
}
